export const hi = {
    translation: {
        b: {
            cancel: 'रद्द करें',
            confirm: 'पुष्टि करें',
            send: 'भेजें',
            done: 'सम्पन्न',
            close: 'बंद करें',
            clear: 'साफ़ करें',
            copy_link: 'लिंक कॉपी करें',
            export: 'निर्यात',
            delete: 'हटाएँ',
            delete_confirm: 'हटाने की पुष्टि करें',
            duplicate: 'डुप्लिकेट',
            share: 'साझा करें',
            sign_in: 'साइन इन',
            sign_up: 'साइन अप',
            email_address: 'ईमेल पता',
            yes: 'हाँ',
            no: 'नहीं',
            back: 'वापस',
            upgrade: 'अपग्रेड करें',
            remove: 'हटाएँ',
            restore: 'पुनर्स्थापित करें',
            archive: 'संग्रहित करें',
            rename: 'नाम बदलें',
            leave: 'छोड़ें',
            import: 'आयात करें',
            continue: 'जारी रखें',
            settings: 'सेटिंग्स',
            log_out: 'लॉग आउट',
            invite: 'आमंत्रित करें',
            invited: 'आमंत्रित किया गया',
        },
        roles: {
            view: 'व्यूअर',
            comment: 'कमेंटर',
            edit: 'संपादक',
            admin: 'एडमिन',
            owner: 'मालिक',
            member: 'सदस्य',
            remove: 'हटाएँ',
            more_roles: 'अन्य भूमिकाएँ...',
            change_role: 'भूमिका बदलें...',
            remove_access: 'एक्सेस हटाएँ...',
            remove_invite: 'आमंत्रण हटाएँ...',
        },
        db_engine: {
            basic: 'बेसिक SQL',
            general: 'जनरल SQL',
        },
        socket_status: {
            reconnecting: 'फिर से कनेक्ट हो रहा है...',
            offline: 'आप ऑफ़लाइन हैं। फिर से कनेक्ट हो रहा है...',
        },
        loader: {
            diagram: 'डायग्राम लोड हो रहा है...',
        },
        m_languages: {
            title: 'भाषाएँ',
            subtitle: 'कोई भाषा चुनें'
        },
        m_feedback: {
            feature: {
                name: 'फ़ीचर अनुरोध',
                desc: 'क्या कोई फ़ीचर नहीं मिल रहा? हमें बताइए — आपके सुझाव महत्वपूर्ण हैं'
            },
            feedback: {
                name: 'अपनी प्रतिक्रिया साझा करें',
                desc: 'हम जानना चाहेंगे कि आप क्या सोचते हैं'
            },
            support: {
                name: 'सहायता',
                desc: 'क्या कुछ ठीक से काम नहीं कर रहा? हमें बताइए — हम इसे जल्दी ठीक करेंगे',
            },
            bug: {
                name: 'समस्या की रिपोर्ट करें',
                desc: 'कुछ सही नहीं लग रहा? इसकी रिपोर्ट करें — हम इसे जल्दी संभालेंगे',
            },
            integration: {
                name: 'इंटीग्रेशन का अनुरोध करें',
                desc: 'आपकी प्रतिक्रिया हमारे लिए बहुत मायने रखती है — एक छोटा सा संदेश छोड़ दें',
            },
        },
        m_feedback_t: {
            feature: {
                name: 'आपके सुझाव के लिए धन्यवाद!',
                desc: 'अपना विचार साझा करने के लिए समय निकालने हेतु धन्यवाद — इससे हमें चीज़ों को बेहतर बनाने में मदद मिलती है।'
            },
            feedback: {
                name: 'आपकी प्रतिक्रिया के लिए धन्यवाद!',
                desc: 'अपना विचार साझा करने के लिए समय निकालने हेतु धन्यवाद — इससे हमें चीज़ों को बेहतर बनाने में मदद मिलती है।'
            },
            support: {
                name: 'संपर्क करने के लिए धन्यवाद!',
                desc: 'सहायता टीम से संपर्क करने के लिए धन्यवाद — हम आपके अनुरोध की समीक्षा करेंगे और जल्द से जल्द जवाब देंगे।',
            },
            bug: {
                name: 'आपकी रिपोर्ट के लिए धन्यवाद!',
                desc: 'इसकी रिपोर्ट करने के लिए धन्यवाद — इससे हमें समस्याओं को तेज़ी से ठीक करने और अनुभव को बेहतर बनाते रहने में मदद मिलती है।',
            },
            contact: {
                name: 'संपर्क करने के लिए धन्यवाद!',
                desc: 'हमें आपका संदेश मिल गया है और हम जल्द से जल्द जवाब देंगे।',
            },
            invite_people: {
                name: 'आमंत्रण सफलतापूर्वक भेजा गया!',
                desc: 'यह बात फैलाने के लिए धन्यवाद — हम उन्हें शामिल करने के लिए उत्साहित हैं।',
            },
            integration: {
                name: 'आपके सुझाव के लिए धन्यवाद!',
                desc: 'अपना विचार साझा करने के लिए समय निकालने हेतु धन्यवाद — इससे हमें चीज़ों को बेहतर बनाने में मदद मिलती है।',
            },
        },
        m_diagram_details: {
            name_place: 'प्रोजेक्ट का नाम दर्ज करें',
            desc_place: 'प्रोजेक्ट का विवरण दर्ज करें'
        },
        m_quick_share: {
            title: 'त्वरित साझा करें',
            subtitle: '(क्वेरी-आधारित लिंक शेयरिंग)'
        },
        m_export_img: {
            title: 'छवि निर्यात करें'
        },
        search_menu: {
            placeholder: 'टेबल, कॉलम, टाइप खोजें...',
            hint: '',
            no_results: 'कोई परिणाम नहीं मिला',
            quick_results: 'त्वरित खोज परिणाम',
            untitled: 'शीर्षकहीन',
            command_tag: 'कमांड',
            section_tables: 'टेबल',
            section_columns: 'कॉलम',
            section_canvas: 'कैनवास',
            section_export: 'निर्यात',
            section_preferences: 'प्राथमिकताएँ',
            section_settings: 'सेटिंग्स',
            type_table: 'टेबल',
            type_note: 'नोट',
            cmd_new_table: 'नई टेबल बनाएँ...',
            cmd_new_note: 'नया नोट बनाएँ...',
            cmd_new_line: 'नई रेखा बनाएँ...',
            cmd_new_area: 'नया क्षेत्र बनाएँ...',
            cmd_export_image: 'छवि निर्यात करें...',
            cmd_export_sql: 'SQL कोड निर्यात करें...',
            cmd_grid_style: 'ग्रिड लेआउट बदलें...',
        },
        canvas_table: {
            more_column: 'और कॉलम',
            more_columns: 'और कॉलम',
            tooltip_table: 'टेबल',
            tooltip_indexes: 'इंडेक्स',
            tooltip_enum: 'Enum',
            tooltip_default: 'डिफ़ॉल्ट',
            tooltip_generated: 'जनरेटेड',
            tooltip_check: 'चेक',
        },
        m_export_code: {
            title: 'कोड {{db_engine}} निर्यात करें',
            download_file: 'फ़ाइल डाउनलोड करें',
            copy_code: 'कोड कॉपी करें'
        },
        m_sign_in_remind: {
            title: 'DB Design आज़माने के लिए धन्यवाद',
            subtitle: 'टेबलों की अधिकतम संख्या बढ़ाने, डायग्राम सहेजने और अधिक फ़ीचर अनलॉक करने के लिए साइन इन या साइन अप करें।'
        },
        m_sign_in_restrict: {
            title: 'ऐप में अधिक करने के लिए साइन इन करें',
            subtitle: 'टेबल सीमाएँ बढ़ाने, डायग्राम सहेजने और अधिक फ़ीचर अनलॉक करने के लिए साइन इन या साइन अप करें।'
        },
        m_new_diagram: {
            title: 'नया डायग्राम',
            subtitle: 'कोई डेटाबेस इंजन चुनें',
            open_diagram: 'डायग्राम खोलें',
            create_diagram: 'डायग्राम बनाएँ',
            no_workspace: 'डायग्राम बनाना शुरू करने के लिए पहले एक वर्कस्पेस बनाएँ।',
            build_something_new: 'चलिए कुछ नया बनाते हैं',
            create_diagram_section: 'डायग्राम बनाएँ',
            clone_template_btn: 'टेम्पलेट क्लोन करें',
        },
        m_diagram_name: {
            enter_new_name: 'नया डायग्राम नाम दर्ज करें',
        },
        m_diagram_clone: {
            header: 'डायग्राम डुप्लिकेट करें',
            copy_of_title: '{{title}} की कॉपी',
        },
        m_diagram_rename: {
            header: 'डायग्राम का नाम बदलें',
        },
        m_template_clone: {
            header: 'टेम्पलेट से डायग्राम बनाएँ',
        },
        m_diagram_delete: {
            header: 'डायग्राम हटाएँ',
            desc_prefix: 'इससे हट जाएगा: ',
        },
        m_diagram_archive: {
            header: 'डायग्राम संग्रहित करें',
            desc_prefix: 'इससे संग्रहित हो जाएगा: ',
        },
        m_diagram_restore: {
            header: 'डायग्राम पुनर्स्थापित करें',
            desc_prefix: 'इससे पुनर्स्थापित हो जाएगा: ',
        },
        m_diagram_import: {
            sql_name: 'SQL कोड आयात करें',
            dbml_name: 'DBML कोड आयात करें',
            placeholder: 'हमें आपके विचार जानने में खुशी होगी!',
        },
        m_diagram_not_found: {
            header: 'डायग्राम नहीं मिला',
            desc: 'हमें आपका खोजा गया डायग्राम नहीं मिल सका।',
            back_to_app: 'ऐप पर वापस जाएँ',
        },
        m_diagram_share: {
            header: 'डायग्राम साझा करें – {{title}}',
            owner_only_invite: 'केवल मालिक ही नए सदस्यों को आमंत्रित कर सकता है',
            invited_to_workspace: 'वर्कस्पेस में आमंत्रित किया गया',
            you: 'आप',
            email_placeholder: 'ईमेल दर्ज करें',
            email_already_in_list: 'यह ईमेल पहले से सूची में है',
            will_be_invited_to_workspace: 'वर्कस्पेस में आमंत्रित किया जाएगा',
        },
        m_invite_people: {
            header: 'वर्कस्पेस में आमंत्रित करें',
        },
        m_invite_revoke: {
            header: 'आमंत्रण हटाएँ',
            desc_prefix: 'इसके लिए आमंत्रण हटाएँ: ',
            desc_suffix: 'यह आमंत्रण काम करना बंद कर देगा।',
        },
        m_member_remove: {
            header: 'सदस्य हटाएँ',
            desc_prefix: 'हटाएँ: ',
            desc_suffix: 'इस वर्कस्पेस से? उनकी एक्सेस समाप्त हो जाएगी।',
        },
        m_template_details: {
            preview: 'पूर्वावलोकन',
            use_template: 'टेम्पलेट का उपयोग करें',
        },
        m_workspace_create: {
            header: 'नया वर्कस्पेस बनाएँ',
            name_label: 'नाम',
            setup_config_label: 'सेटअप कॉन्फ़िगरेशन',
            setup_config_value: 'खाली वर्कस्पेस',
            template_structure_label: 'टेम्पलेट/संरचना',
            template_structure_value: 'संरचना प्रीलोड करें',
            placeholder: 'वर्कस्पेस का नाम दर्ज करें',
            create_button: 'वर्कस्पेस बनाएँ',
            creating: 'आपका वर्कस्पेस बनाया जा रहा है...',
        },
        m_workspace_delete: {
            header: 'वर्कस्पेस हटाएँ',
            desc_prefix: 'इससे स्थायी रूप से हट जाएगा: ',
            confirm_prefix: 'पुष्टि के लिए ',
            confirm_suffix: ' टाइप करें।',
        },
        m_workspace_leave: {
            header: 'वर्कस्पेस छोड़ें',
            desc_prefix: 'इससे आप हट जाएँगे: ',
            desc_suffix: 'फिर से शामिल होने के लिए आपको दोबारा आमंत्रित किया जाना होगा।',
        },
        m_workspace_menu: {
            manage_members: 'सदस्य प्रबंधित करें',
            switch_workspace: 'वर्कस्पेस बदलें',
            workspaces_label: 'वर्कस्पेस',
            create_workspace: 'वर्कस्पेस बनाएँ...',
            switching: 'बदला जा रहा है',
        },
        m_profile_menu: {
            profile: 'प्रोफ़ाइल',
            onboarding: 'ऑनबोर्डिंग',
        },
        m_pricing_limit: {
            admin_roles: { title: 'अपने सहयोग को अगले स्तर पर ले जाएँ', description: 'एडमिन, संपादक, कमेंटर, व्यूअर जैसी अधिक शेयरिंग भूमिकाएँ अनलॉक करने के लिए अपग्रेड करें।' },
            workspaces: { title: 'आप तेज़ी से आगे बढ़ रहे हैं!', description: 'अपने प्रोजेक्ट्स और टीमों के लिए और वर्कस्पेस बनाने और प्रबंधित करने हेतु अपग्रेड करें।' },
            workspaces_canvas: { title: 'अपने वर्कस्पेस का विस्तार करें', description: 'अपने प्रोजेक्ट्स और टीमों के लिए और वर्कस्पेस बनाने और प्रबंधित करने हेतु अपग्रेड करें।' },
            members: { title: 'बड़े पैमाने पर सहयोग करें', description: 'अपने वर्कस्पेस में और सदस्य जोड़ने और अधिक प्रभावी ढंग से सहयोग करने के लिए अपग्रेड करें।' },
            diagrams: { title: 'आप तेज़ी से आगे बढ़ रहे हैं!', description: 'अधिक डायग्राम बनाने और आत्मविश्वास के साथ अपने प्रोजेक्ट्स को बढ़ाने के लिए अपग्रेड करें।' },
            tables: { title: 'बिना किसी सीमा के बनाएँ', description: 'अधिक टेबल जोड़ने और बड़े, अधिक विस्तृत डायग्राम बनाना जारी रखने के लिए अपग्रेड करें।' },
            columns: { title: 'बिना किसी सीमा के बनाएँ', description: 'अधिक कॉलम जोड़ने और बड़े, अधिक विस्तृत डायग्राम बनाना जारी रखने के लिए अपग्रेड करें।' },
            notes: { title: 'बिना किसी सीमा के बनाएँ', description: 'अधिक नोट्स जोड़ने और बड़े, अधिक विस्तृत डायग्राम बनाना जारी रखने के लिए अपग्रेड करें।' },
            areas: { title: 'बिना किसी सीमा के बनाएँ', description: 'अधिक क्षेत्र जोड़ने और बड़े, अधिक विस्तृत डायग्राम बनाना जारी रखने के लिए अपग्रेड करें।' },
            pens: { title: 'बिना किसी सीमा के बनाएँ', description: 'अधिक ड्रॉइंग जोड़ने और बड़े, अधिक विस्तृत डायग्राम बनाना जारी रखने के लिए अपग्रेड करें।' },
            default_title: 'अपने सहयोग को अगले स्तर पर ले जाएँ',
            default_title_canvas: 'अपने प्रदर्शन को अगले स्तर पर ले जाएँ',
        },
        m_pricing_plans: {
            title: 'अपनी योजना अपग्रेड करें',
            subtitle: 'आप बाद में कभी भी अपनी योजना को अपग्रेड या डाउनग्रेड कर सकते हैं',
            monthly: 'मासिक',
            annually: 'वार्षिक',
            billed_annually: 'वार्षिक बिलिंग',
            billed_monthly: 'मासिक बिलिंग',
            free_for_everyone: 'सभी के लिए मुफ़्त',
            current_plan: 'वर्तमान योजना',
            will_be_available_soon: 'जल्द उपलब्ध होगा',
            price_period_user_month: '/उपयोगकर्ता/माह',
            plan_free: {
                name: 'मुफ़्त',
                button: 'योजना बदलें',
                feature_realtime: 'रीयल-टाइम सहयोग',
                feature_members: '4 सदस्य / वर्कस्पेस',
                feature_diagrams: '4 डायग्राम / वर्कस्पेस',
                feature_tables: '40 टेबल / डायग्राम',
            },
            plan_pro: {
                name: 'Pro',
                feature_all_free: 'मुफ़्त की सभी सुविधाएँ +',
                feature_members: 'असीमित सदस्य',
                feature_diagrams: 'असीमित डायग्राम',
                feature_tables: 'असीमित टेबल',
                feature_history: 'वर्शन इतिहास',
                feature_admin_roles: 'एडमिन भूमिकाएँ',
            },
        },
        sidebar: {
            new: 'नया',
            pinned_diagrams: 'पिन किए गए डायग्राम',
            pin_hint: 'यहाँ देखने के लिए डायग्राम पिन करें',
            expand_sidebar: 'साइडबार विस्तृत करें',
            home_aria: 'DB Design होम',
            open_menu: 'मेनू खोलें',
            close_menu: 'मेनू बंद करें',
            sidebar_menu_aria: 'साइडबार मेनू',
            plan_suffix: 'योजना',
            diagram_options: 'डायग्राम विकल्प',
            pin: 'पिन करें',
            unpin: 'अनपिन करें',
            edit_details: 'विवरण संपादित करें',
            see_details: 'विवरण देखें',
            invite_people: 'आमंत्रित करें',
            collapse_sidebar: 'साइडबार संक्षिप्त करें',
            close_sidebar: 'साइडबार बंद करें',
            open_sidebar: 'साइडबार खोलें',
            open_new_tab: 'नए टैब में खोलें',
        },
        focus_controls: {
            show_top: 'ऊपरी नियंत्रण दिखाएँ',
            hide_top: 'ऊपरी नियंत्रण छिपाएँ',
            show_left: 'बाएँ नियंत्रण दिखाएँ',
            hide_left: 'बाएँ नियंत्रण छिपाएँ',
        },
        m_keyboard_shortcuts: {
            title: 'कीबोर्ड शॉर्टकट',
            general: {
                title1: 'सामान्य',
                title2: '',
                items: {
                    new_diagram: 'डायग्राम बनाएँ',
                    new_chat: 'नई चैट',
                    search: 'त्वरित क्रियाएँ या खोज',
                    preferences: 'प्राथमिकताएँ',
                    settings: 'सेटिंग्स',
                    keyboard_shortcuts: 'कीबोर्ड शॉर्टकट',
                    toggle_sidebar: 'साइडबार टॉगल करें',
                    toggle_theme: 'थीम टॉगल करें',
                },
            },
            ctrl_left: {
                title1: 'नियंत्रण',
                title2: '(बाएँ)',
                items: {
                    mouse_sel: 'माउस चयन / हैंड मोड',
                    table: 'टेबल',
                    line: 'रेखा',
                    area: 'क्षेत्र',
                    note: 'नोट',
                    comment: 'टिप्पणी',
                    pen: 'पेंसिल',
                    undo: 'पूर्ववत्',
                    redo: 'दोहराएँ'
                },
            },
            ctrl_top_left: {
                title1: 'नियंत्रण',
                title2: '(ऊपर-बाएँ)',
                items: {
                    export_img: 'छवि निर्यात करें',
                    search: 'खोजें',
                    editor_panel: 'एडिटर पैनल',
                    zoom_to_fit: 'स्क्रीन के अनुसार फिट करें',
                },
            },
            ctrl_bottom_right: {
                title1: 'नियंत्रण',
                title2: '(नीचे-दाएँ)',
                items: {
                    minimap: 'मिनिमैप',
                    full_screen: 'पूर्ण स्क्रीन',
                    zoom_in: 'ज़ूम इन',
                    zoom_out: 'ज़ूम आउट',
                    zoom_100: '100% पर ज़ूम'
                },
            },
            ctx_tab: {
                title1: 'प्रासंगिक मेनू',
                title2: '(टेबल)',
                items: {
                    dupl_tab: 'टेबल डुप्लिकेट करें',
                    del_tab: 'टेबल हटाएँ'
                },
            },
            ctx_del_tab: {
                title1: 'प्रासंगिक मेनू',
                title2: '(टेबल हटाएँ)',
                items: {
                    yes: 'हाँ',
                    no: 'नहीं'
                },
            },
            ctx_tab_col: {
                title1: 'प्रासंगिक मेनू',
                title2: '(टेबल कॉलम)',
                items: {
                    add_col_below: 'नीचे नया कॉलम जोड़ें',
                    focus_col_above: 'ऊपर वाले कॉलम पर फोकस',
                    focus_col_below: 'नीचे वाले कॉलम पर फोकस',
                    move_col_up: 'कॉलम ऊपर ले जाएँ',
                    move_col_down: 'कॉलम नीचे ले जाएँ',
                    dupl_col: 'कॉलम डुप्लिकेट करें',
                    del_col: 'कॉलम हटाएँ'
                },
            },
            ctx_line: {
                title1: 'प्रासंगिक मेनू',
                title2: '(रेखा)',
                items: {
                    del_line: 'रेखा हटाएँ'
                },
            },
            ctx_area: {
                title1: 'प्रासंगिक मेनू',
                title2: '(क्षेत्र)',
                items: {
                    dupl_area: 'क्षेत्र डुप्लिकेट करें',
                    del_area: 'क्षेत्र हटाएँ'
                },
            },
            ctx_multi: {
                title1: 'प्रासंगिक मेनू',
                title2: '(मल्टीसेलेक्ट)',
                items: {
                    select_all: 'सभी तत्व चुनें',
                    create_area_for_select_els: 'चयनित तत्वों के लिए क्षेत्र बनाएँ',
                    dupl_select_els: 'चयनित तत्व डुप्लिकेट करें',
                    del_select_els: 'चयनित तत्व हटाएँ'
                },
            },
        },
        t: {
            ctrl_left: {
                mouse_select: 'माउस चयन',
                table: 'टेबल',
                line: 'रेखा',
                area: 'क्षेत्र',
                note: 'नोट',
                comment: 'टिप्पणी',
                pen: 'पेंसिल',
                undo: 'पूर्ववत्',
                redo: 'दोहराएँ'
            },
            ctrl_top_left: {
                home: 'होम',
                name: 'डायग्राम जानकारी',
                editor: 'एडिटर',
                search: 'खोज',
                export: 'निर्यात विकल्प',
                view_mode: 'दृश्य मोड',
                zoom_to_fit: 'स्क्रीन के अनुसार फिट करें',
                grid: 'ग्रिड लेआउट',
                history: 'इतिहास',
                main_menu: 'मुख्य मेनू',
                new_diagram: 'नया डायग्राम',
            },
            ctrl_top_right: {
                feature_req: 'फ़ीचर अनुरोध',
                feedback: 'प्रतिक्रिया भेजें',
                sign_in: 'साइन इन',
                quick_share: 'त्वरित साझा'
            },
            ctrl_bottom_right: {
                full_screen: 'पूर्ण स्क्रीन',
                minimap: 'मिनिमैप',
                zoom_out: 'ज़ूम आउट',
                zoom_100: '100% पर ज़ूम',
                zoom_in: 'ज़ूम इन',
                info: 'जानकारी व संसाधन'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'डिफ़ॉल्ट',
                        blue: 'नीला',
                        green: 'हरा',
                        red: 'लाल',
                        purple: 'बैंगनी',
                        violet: 'वायलेट'
                    },
                    borders: {
                        none: 'कोई नहीं',
                        solid: 'सॉलिड',
                        dashed: 'डैश्ड',
                        dotted: 'डॉटेड'
                    },
                    color: 'रंग',
                    border: 'बॉर्डर',
                    description: 'विवरण',
                    description_table_place: 'तालिका का विवरण',
                    description_column_place: 'कॉलम का विवरण',
                    description_line_place: 'रेखा का विवरण',
                    description_note_place: 'नोट का विवरण',
                    description_area_place: 'क्षेत्र का विवरण',
                    description_pen_place: 'पेंसिल का विवरण',
                    hide_menu: 'मेनू छिपाएँ',
                    show_menu: 'मेनू दिखाएँ'
                },
                tab_col: {
                    add_col_below: 'नीचे कॉलम जोड़ें',
                    add_col_above: 'ऊपर कॉलम जोड़ें',
                    key: 'Key',
                    keys: {
                        none: 'कोई नहीं',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'कोई नहीं',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'कॉलम नीचे ले जाएँ',
                    move_col_up: 'कॉलम ऊपर ले जाएँ',
                    more_functions: 'अधिक फ़ंक्शन'
                },
                line: {
                    change_connects: 'कनेक्टर्स बदलें',
                    connects: {
                        empty: 'खाली',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_many_to: 'One or Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'ON Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: 'तत्व फ़िल्टर करें'
                },
                note: {
                    link_placeholder: 'लिंक दर्ज करें',
                    link_apply: 'जोड़ें',
                    link_remove: 'हटाएँ',
                    link_edit: 'संपादित करें',
                    link_needs_selection: 'लिंक जोड़ने के लिए टेक्स्ट चुनें',
                    bulleted_list: 'सूची',
                    numbered_list: 'क्रमांकित सूची',
                    font_style: 'फ़ॉन्ट शैली',
                    alignment: 'संरेखण',
                    align_left: 'बाएँ संरेखित करें',
                    align_center: 'बीच में संरेखित करें',
                    align_right: 'दाएँ संरेखित करें',
                    link: 'लिंक',
                    monospace: 'मोनोस्पेस',
                    bold: 'बोल्ड',
                    italic: 'इटैलिक',
                    underline: 'अंडरलाइन',
                    strikethrough: 'स्ट्राइकथ्रू',
                },
                multi: {
                    filter: 'चयन फ़िल्टर करें',
                    create_area: 'क्षेत्र बनाएँ'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'पूर्ण',
            keys_only: 'केवल कुंजियाँ',
            names_only: 'केवल नाम'
        },
        dropdown_ctrl_grid: {
            none: 'कोई नहीं',
            lines: 'रेखाएँ',
            dots: 'डॉट्स',
        },
        dropdown_ctrl_export: {
            export_img: 'छवि निर्यात करें',
            export_code: 'SQL कोड निर्यात करें'
        },
        dropdown_ctrl_settings: {
            back_home: 'होम पर वापस जाएँ',
            sign_in: 'साइन इन',
            preferences: 'प्राथमिकताएँ',
            new_project: 'नया प्रोजेक्ट',
            import_diagram: 'डायग्राम आयात करें',
            duplicate_diagram: 'डायग्राम डुप्लिकेट करें',
            keyboard_shortcuts: 'कीबोर्ड शॉर्टकट',
            languages: 'भाषाएँ',
            view: 'व्यू',
            upgrade_plan: 'योजना अपग्रेड करें',
            language: 'भाषा',
            mouse_trackpad: 'माउस या ट्रैकपैड',
            background_color: 'पृष्ठभूमि रंग',
            grid_layout: 'ग्रिड लेआउट',
            view_mode: 'व्यू मोड',
            show_align_lines: 'संरेखण रेखाएँ दिखाएँ',
            show_members_cursors: 'सदस्यों के कर्सर दिखाएँ',
            show_comments: 'टिप्पणियाँ दिखाएँ',
            undo_redo_controls: 'पूर्ववत्/दोहराएँ नियंत्रण',
            show_scrollbars: 'स्क्रॉलबार दिखाएँ',
            opt_auto: 'स्वचालित',
            opt_trackpad: 'ट्रैकपैड',
            opt_mouse: 'माउस',
            opt_default: 'डार्क (डिफ़ॉल्ट)',
            opt_gray: 'ग्रे',
            opt_blue: 'नीला',
            opt_purple: 'बैंगनी',
            opt_violet: 'वायलेट',
            opt_green: 'हरा',
            opt_red: 'लाल',
            opt_yellow: 'पीला',
            opt_dots: 'डॉट्स',
            opt_lines: 'रेखाएँ',
            opt_none: 'कोई नहीं',
            opt_full: 'पूर्ण',
            opt_keys: 'कुंजियाँ',
            opt_names: 'नाम',
        },
        dropdown_ctrl_info_resources: {
            feedback: 'प्रतिक्रिया',
            keyboard_shortcuts: 'कीबोर्ड शॉर्टकट',
            languages: 'भाषाएँ',
            homepage: 'मुखपृष्ठ'
        },
        n: {
            default: 'लोड हो रहा है…',
            file_ready_to_download: 'फ़ाइल डाउनलोड के लिए तैयार है',
            code_copied: 'कोड कॉपी कर दिया गया है',
            link_copied: 'लिंक कॉपी कर दिया गया है',
            username_copied: 'उपयोगकर्ता नाम कॉपी कर दिया गया है',
            email_copied: 'ईमेल कॉपी कर दिया गया है',
            please_enter_message: 'कृपया संदेश दर्ज करें',
            invalid_email: 'ईमेल पता मान्य नहीं है',
            note_link_unsupported_protocol: 'यह लिंक प्रकार समर्थित नहीं है। https, http, mailto का उपयोग करें।',
            something_wrong_contact: 'कुछ गड़बड़ हो गई। कृपया पृष्ठ रीलोड करें या हमसे संपर्क करें।',
            something_wrong: 'कुछ गड़बड़ हो गई। कृपया पृष्ठ रीलोड करें',
            sending: 'भेजा जा रहा है…',
            request_sent: 'अनुरोध भेज दिया गया है। धन्यवाद!',

            please_enter_email: 'कृपया ईमेल पता दर्ज करें',
            changing: 'बदला जा रहा है...',
            role_changed: 'भूमिका बदल दी गई',
            removing: 'हटाया जा रहा है...',
            member_removed: 'सदस्य हटा दिया गया',
            inviting: 'आमंत्रित किया जा रहा है...',
            invite_sent: 'आमंत्रण भेज दिया गया',
            added_to_diagram: 'डायग्राम में जोड़ा गया',
            invite_removed: 'आमंत्रण हटा दिया गया',
            role_not_allowed_on_plan: 'यह भूमिका आपकी योजना में उपलब्ध नहीं है। इसे असाइन करने के लिए अपग्रेड करें।',
            already_diagram_member: 'इस व्यक्ति के पास पहले से डायग्राम की एक्सेस है।',
            cannot_invite_to_workspace: 'इस व्यक्ति को वर्कस्पेस में आमंत्रित करने के लिए किसी वर्कस्पेस एडमिन से कहें।',
            saving: 'सहेजा जा रहा है...',
            saved: 'सहेजा गया',
            diagram_renamed: 'डायग्राम का नाम बदल दिया गया',
            diagram_updated: 'डायग्राम अपडेट कर दिया गया',
            duplicating: 'डुप्लिकेट किया जा रहा है...',
            diagram_duplicated: 'डायग्राम डुप्लिकेट कर दिया गया',
            deleting: 'हटाया जा रहा है...',
            diagram_archived: 'डायग्राम संग्रहित कर दिया गया',
            diagram_deleted: 'डायग्राम हटा दिया गया',
            restoring: 'पुनर्स्थापित किया जा रहा है...',
            diagram_restored: 'डायग्राम पुनर्स्थापित कर दिया गया',
            diagram_pinned: 'डायग्राम पिन कर दिया गया',
            diagram_unpinned: 'डायग्राम अनपिन कर दिया गया',
            creating: 'बनाया जा रहा है...',
            diagram_created: 'डायग्राम बना दिया गया',
            forbidden: 'आपके पास इसकी एक्सेस नहीं है।',
            invite_already_pending: 'इस व्यक्ति के पास पहले से एक लंबित आमंत्रण है।',
            already_member: 'पहले से ही वर्कस्पेस का सदस्य है',
            cannot_invite_self: 'आप खुद को आमंत्रित नहीं कर सकते',
            workspace_not_found: 'वर्कस्पेस नहीं मिला। पृष्ठ रीफ़्रेश करें और फिर से प्रयास करें।',
            diagram_not_found: 'डायग्राम नहीं मिला।',
            has_diagram_members: 'डायग्राम में सक्रिय सदस्य हैं',
            seat_limit_reached: 'आप अपनी योजना की सीट सीमा तक पहुँच गए हैं। अधिक लोगों को आमंत्रित करने के लिए अपग्रेड करें।',
            feature_not_in_plan: 'यह फ़ीचर आपकी वर्तमान योजना में शामिल नहीं है।',
            subscription_expired: 'आपकी सदस्यता समाप्त हो गई है। इसका उपयोग जारी रखने के लिए नवीनीकृत करें।',
            subscription_inactive: 'आपकी सदस्यता निष्क्रिय है। कृपया बिलिंग अपडेट करें।',
            plan_limit_generic: 'आपकी योजना इस क्रिया की अनुमति नहीं देती। जारी रखने के लिए अपग्रेड करें।',

            // Auth / profile
            session_expired: 'आपका सत्र समाप्त हो गया है — कृपया फिर से साइन इन करें।',
            profile_updated: 'प्रोफ़ाइल अपडेट कर दी गई',
            profile_update_failed: 'प्रोफ़ाइल अपडेट करने में विफल।',
            account_delete_failed: 'खाता हटाने में विफल।',

            // Preferences
            couldnt_save: 'बदलाव सहेजे नहीं जा सके',
            try_again: 'कुछ गड़बड़ हो गई। कृपया फिर से प्रयास करें।',

            // Workspace
            not_workspace_member: 'आप उस वर्कस्पेस के सदस्य नहीं हैं।',
            workspace_switch_failed: 'वर्कस्पेस बदला नहीं जा सका। कृपया फिर से प्रयास करें।',
            workspace_create_failed: 'वर्कस्पेस बनाया नहीं जा सका। कृपया फिर से प्रयास करें।',
            invalid_workspace_name: 'वर्कस्पेस का नाम मान्य नहीं है',
            workspace_updated: 'वर्कस्पेस अपडेट कर दिया गया',
            workspace_update_failed: 'वर्कस्पेस अपडेट नहीं किया जा सका। कृपया फिर से प्रयास करें।',
            last_owner_cannot_leave: 'आप एकमात्र मालिक हैं। छोड़ने से पहले किसी और को मालिक बनाएँ, या वर्कस्पेस हटाएँ।',
            workspace_leave_failed: 'वर्कस्पेस छोड़ा नहीं जा सका। कृपया फिर से प्रयास करें।',
            workspace_delete_forbidden: 'केवल वर्कस्पेस का मालिक ही इस वर्कस्पेस को हटा सकता है।',
            workspace_has_active_billing: 'इसे हटाने से पहले इस वर्कस्पेस की सदस्यता रद्द करें।',
            workspace_deleted: 'वर्कस्पेस हटा दिया गया',
            workspace_delete_failed: 'वर्कस्पेस हटाया नहीं जा सका। कृपया फिर से प्रयास करें।',
            member_remove_forbidden: 'आपके पास इस सदस्य को हटाने की अनुमति नहीं है।',
            member_remove_failed: 'सदस्य हटाया नहीं जा सका। कृपया फिर से प्रयास करें।',
            cannot_remove_self: 'खुद को हटाने के लिए "वर्कस्पेस छोड़ें" का उपयोग करें।',
            cannot_remove_last_owner: 'वर्कस्पेस में हमेशा एक मालिक होना चाहिए। पहले किसी और को मालिक बनाएँ।',
            invite_revoke_forbidden: 'आपके पास इस आमंत्रण को रद्द करने की अनुमति नहीं है।',
            invite_revoke_failed: 'आमंत्रण रद्द नहीं किया जा सका। कृपया फिर से प्रयास करें।',
        },
        dashboard: {
            doc_title: 'डायग्राम',
            filter_all: 'सभी',
            filter_mydiagrams: 'मेरे डायग्राम',
            filter_shared: 'मेरे साथ साझा किए गए',
            filter_archived: 'संग्रहीत',
            empty_all: '"सभी डायग्राम" में कोई डायग्राम नहीं है',
            empty_mydiagrams: '"मेरे डायग्राम" में कोई डायग्राम नहीं है',
            empty_shared: '"मेरे साथ साझा किए गए" में कोई डायग्राम नहीं है',
            empty_archived: '"संग्रहीत" में कोई डायग्राम नहीं है',
            example_diagram_badge: 'उदाहरण डायग्राम',
            import_sql: 'SQL',
            import_dbml: 'DBML',
            import_playground: 'Playground',
        },
        settings_page: {
            nav: {
                back_to_app: 'ऐप पर वापस जाएँ',
                group_personal: 'व्यक्तिगत',
                group_organization: 'संगठन',
                billing: 'बिलिंग',
            },
            profile: {
                member_since: '{{date}} से सदस्य',
                general: 'सामान्य',
                email: 'ईमेल',
                full_name: 'पूरा नाम',
                full_name_placeholder: 'नाम दर्ज करें',
                account_protection: 'खाता सुरक्षा',
                mfa_label: 'बहु-कारक प्रमाणीकरण (MFA)',
                mfa_sub: 'खाते के लिए अतिरिक्त सुरक्षा परत · जल्द आ रहा है',
                mfa_enable: 'MFA सक्षम करें',
                mfa_soon_tooltip: 'जल्द ही उपलब्ध होगा',
                workspace_access: 'वर्कस्पेस एक्सेस',
                leave_workspace: 'वर्कस्पेस छोड़ें',
                leave_workspace_sub: 'खुद को वर्कस्पेस से हटाएँ',
                leave_owner_tooltip: 'वर्कस्पेस छोड़ने से पहले स्वामित्व स्थानांतरित करें',
            },
            workspace: {
                header: 'वर्कस्पेस',
                general: 'सामान्य',
                name_label: 'वर्कस्पेस का नाम',
                name_placeholder: 'वर्कस्पेस का नाम',
                stat_member_singular: 'सदस्य',
                stat_member_plural: 'सदस्य',
                stat_team_singular: 'टीम',
                stat_team_plural: 'टीमें',
                members_section: 'सदस्य',
                no_members: 'कोई सदस्य नहीं',
                count_member_singular: 'सदस्य',
                count_member_plural: 'सदस्य',
                view_members_btn: 'सदस्य देखें',
                danger_zone: 'खतरनाक क्षेत्र',
                delete_workspace: 'वर्कस्पेस हटाएँ',
                delete_workspace_sub: 'यह वर्कस्पेस को स्थायी रूप से हटा देगा',
                delete_owner_only_tooltip: 'केवल स्वामी ही वर्कस्पेस हटा सकते हैं',
                delete_cancel_sub_tooltip: 'वर्कस्पेस हटाने से पहले अपनी सदस्यता रद्द करें',
            },
            members: {
                header: 'सदस्य',
                col_name: 'नाम',
                col_email: 'ईमेल',
                col_role: 'भूमिका',
                col_joined: 'शामिल हुए',
                active_members: 'सक्रिय सदस्य',
                invited_section: 'आमंत्रित',
                no_members: 'अभी तक कोई सदस्य नहीं है।',
                options_aria: 'विकल्प',
                leave_workspace_item: 'वर्कस्पेस छोड़ें...',
                remove_member_item: 'सदस्य हटाएँ...',
                remove_owner_only_tooltip: 'केवल स्वामी ही सदस्यों को हटा सकते हैं',
                remove_owner_row_tooltip: 'स्वामी को वर्कस्पेस से नहीं हटाया जा सकता',
                remove_invite_item: 'आमंत्रण हटाएँ...',
                role_invited_suffix: '{{role}} (आमंत्रित)',
            },
            preferences: {
                section_general: 'सामान्य',
                section_diagram_defaults: 'डायग्राम सेटिंग्स',
                section_diagram_views: 'डायग्राम दृश्य',
                section_notifications: 'सूचनाएँ',
                theme_label: 'इंटरफ़ेस थीम',
                theme_sub: 'अपनी इंटरफ़ेस रंग योजना चुनें',
                theme_dark: 'डार्क',
                theme_light: 'लाइट',
                theme_system: 'सिस्टम',
                language_sub: 'अपनी इंटरफ़ेस भाषा चुनें',
                timezone_label: 'समय क्षेत्र',
                timezone_sub: 'अपना समय क्षेत्र चुनें',
                timezone_options: {
                    honolulu: 'GMT-10:00 — हवाई',
                    anchorage: 'GMT-09:00 — अलास्का',
                    los_angeles: 'GMT-08:00 — प्रशांत समय',
                    denver: 'GMT-07:00 — माउंटेन समय',
                    chicago: 'GMT-06:00 — सेंट्रल समय',
                    new_york: 'GMT-05:00 — ईस्टर्न समय',
                    caracas: 'GMT-04:00 — कराकास',
                    sao_paulo: 'GMT-03:00 — साओ पाउलो',
                    azores: 'GMT-01:00 — अज़ोरेस',
                    london: 'GMT+00:00 — लंदन',
                    paris: 'GMT+01:00 — पेरिस, बर्लिन',
                    kyiv: 'GMT+02:00 — कीव, एथेंस',
                    istanbul: 'GMT+03:00 — इस्तांबुल',
                    dubai: 'GMT+04:00 — दुबई',
                    karachi: 'GMT+05:00 — कराची',
                    kolkata: 'GMT+05:30 — भारत',
                    dhaka: 'GMT+06:00 — ढाका',
                    bangkok: 'GMT+07:00 — बैंकॉक, जकार्ता',
                    shanghai: 'GMT+08:00 — बीजिंग, सिंगापुर',
                    tokyo: 'GMT+09:00 — टोक्यो, सियोल',
                    sydney: 'GMT+10:00 — सिडनी',
                    auckland: 'GMT+12:00 — ऑकलैंड',
                },
                input_mode_sub: 'कैनवास नेविगेशन नियंत्रण चुनें',
                background_sub: 'कैनवास के लिए एक पृष्ठभूमि रंग चुनें',
                grid_sub: 'कैनवास ग्रिड लेआउट चुनें',
                show_align_lines_sub: 'ऑब्जेक्ट संरेखित करते समय रेखाएँ दिखाएँ',
                show_cursors_sub: 'अन्य सहयोगियों के कर्सर दिखाएँ',
                show_comments_sub: 'कैनवास पर टिप्पणियाँ दिखाएँ',
                show_scrollbars_sub: 'कैनवास नेविगेट करते समय स्क्रॉलबार दिखाएँ',
                show_undo_redo_label: 'पूर्ववत/फिर से करें नियंत्रण दिखाएँ',
                show_undo_redo_sub: 'परिवर्तनों को पूर्ववत और फिर से करने के लिए नियंत्रण दिखाएँ',
                notif_shared_label: 'मेरे साथ साझा किया गया डायग्राम',
                notif_shared_sub: 'जब कोई मेरे साथ डायग्राम साझा करे',
                notif_mentions_label: 'टिप्पणियों में उल्लेख',
                notif_mentions_sub: 'जब कोई टिप्पणी में मुझे @उल्लेख करे',
                notif_updates_label: 'उत्पाद अपडेट',
                notif_updates_sub: 'नई सुविधाओं और सुधारों पर मासिक अपडेट',
                show: 'दिखाएँ',
                hide: 'छिपाएँ',
                on: 'चालू',
                off: 'बंद',
            },
            billing: {
                header: 'बिलिंग',
                plan_free: 'फ्री प्लान',
                status_current: 'वर्तमान',
                no_renewal_needed: 'नवीनीकरण की आवश्यकता नहीं',
                payment_header: 'भुगतान',
                no_payments: 'कोई भुगतान नहीं',
                invoices_header: 'इनवॉइस',
                no_invoices: 'कोई इनवॉइस नहीं',
            },
            usage: {
                doc_title: 'उपयोग',
                overview_title: 'अवलोकन',
                resource_limits_title: 'संसाधन सीमाएँ',
                label_diagrams: 'डायग्राम',
                label_tables: 'टेबल',
                label_areas: 'क्षेत्र',
                label_notes: 'स्टिकी नोट्स',
                label_members: 'सदस्य',
                label_tables_per_diagram: 'टेबल / डायग्राम',
                label_areas_per_diagram: 'क्षेत्र / डायग्राम',
                label_notes_per_diagram: 'नोट्स / डायग्राम',
                need_more_title: 'और चाहिए?',
                need_more_free: 'अधिक डायग्राम, वर्शन हिस्ट्री और प्राथमिकता सहायता के लिए Basic में अपग्रेड करें।',
                need_more_paid: 'असीमित डायग्राम, सीटें और उन्नत सुविधाओं के लिए Professional में अपग्रेड करें।',
            },
        },
        pages: {
            not_found: {
                page_not_found: 'पृष्ठ नहीं मिला',
                dont_have_access_to_diagram: 'आपके पास इस डायग्राम की एक्सेस नहीं है या यह अब मौजूद नहीं है।',
                back_home: 'होम पर वापस जाएँ'
            },
            error: {
                title: 'त्रुटि',
                link_is_invalid: 'यह लिंक अमान्य है या गलत तरीके से दर्ज किया गया है।',
                something_wrong: 'कुछ गड़बड़ हो गई।',
                back_home: 'होम पर वापस जाएँ',
                please_try_later: 'कृपया बाद में फिर से प्रयास करें',
            },
            billing_success: {
                doc_title: 'प्लान अपग्रेड हो गया',
                heading: 'भुगतान सफल',
                subtitle: 'आपका प्लान सफलतापूर्वक अपग्रेड कर दिया गया है।',
                cta: 'डिज़ाइन करना शुरू करें',
            },
            email_verified: {
                doc_title: 'ईमेल सत्यापित',
            },
            forgot_password: {
                doc_title: 'पासवर्ड भूल गए',
            },
            password_updated: {
                doc_title: 'पासवर्ड अपडेट हो गया',
            },
            reset_password: {
                doc_title: 'पासवर्ड रीसेट करें',
            },
            check_email: {
                doc_title: 'अपना ईमेल जांचें',
            },
            sign_in: {
                doc_title: '{{product}} में साइन इन करें',
            },
            sign_up: {
                doc_title: '{{product}} के लिए साइन अप करें',
            },
        },
    },
};

export const hiMeta = {
    lang_origin: 'हिंदी',
    lang_eng: 'Hindi',
    lang_code: 'hi',
};
